import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickNavigationSection = () => {
  const navigationItems = [
    {
      label: 'View Stats',
      path: '/stats',
      icon: 'BarChart3',
      description: 'Progress analytics and completion rates',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      hoverBg: 'hover:bg-blue-100'
    },
    {
      label: 'Browse History',
      path: '/history',
      icon: 'Clock',
      description: 'Review past goals and achievements',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      hoverBg: 'hover:bg-green-100'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-gentle p-6">
      {/* Section Header */}
      <div className="flex items-center space-x-3 mb-4">
        <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
          <Icon name="Navigation" size={16} color="white" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-foreground">
            Quick Navigation
          </h3>
          <p className="text-sm text-muted-foreground">
            Explore your progress and history
          </p>
        </div>
      </div>
      {/* Navigation Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {navigationItems?.map((item) => (
          <Link
            key={item?.path}
            to={item?.path}
            className={`flex items-start space-x-3 p-4 ${item?.bgColor} ${item?.hoverBg} rounded-lg border border-transparent hover:border-current transition-all duration-200 animate-spring group`}
          >
            <div className={`flex items-center justify-center w-10 h-10 bg-white rounded-lg shadow-gentle group-hover:shadow-gentle-hover transition-all duration-200`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className={`font-caption font-semibold ${item?.color} group-hover:text-opacity-80 transition-colors duration-200`}>
                {item?.label}
              </h4>
              <p className="text-sm text-muted-foreground mt-1">
                {item?.description}
              </p>
            </div>
            <Icon 
              name="ArrowRight" 
              size={16} 
              className={`${item?.color} opacity-0 group-hover:opacity-100 transition-opacity duration-200 mt-1`}
            />
          </Link>
        ))}
      </div>
      {/* Daily Tip */}
      <div className="mt-4 p-3 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Lightbulb" size={16} className="text-accent mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium">Daily Tip</p>
            <p className="text-xs text-muted-foreground mt-1">
              Review your stats regularly to identify patterns and celebrate progress. Small consistent actions lead to significant results.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickNavigationSection;